// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleBubble__content-b8c7cf {
  max-width: 100%;
  width: 100vw;
  background-color: inherit;
}

.ArticleBubble__bubble-eaee43 {
  border-radius: 20px;
  border: 1px solid var(--base-17);
  padding: 0 0 2px 0;
}

.ArticleBubble__bubble-eaee43:after {
  content: "";
  display: table;
  clear: both;
}

.ArticleBubble__quote-f87763 {
  margin-bottom: 9px;
}

.ArticleBubble__forward-ba529f {
  padding: 8px 12px 0;
  margin-bottom: 4px;
}

.ArticleBubble__status-bar-cbec2a {
  float: right;
  margin: 4px 8px 10px 8px;
}

.ArticleBubble__sender-name-b34ede {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ArticleBubble__sender-name-b34ede.ArticleBubble__wide-gap-cc7b5a {
  margin-bottom: 4px;
}

.ArticleBubble__thread-button-cb5a64 {
  margin: 2px 0 -2px 0;
}

.ArticleBubble__translate-b13d66 {
  margin: 2px 0px -2px 0px;
  padding-inline-end: 8px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/ArticleBubble/ArticleBubble.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,wBAAA;EACA,uBAAA;EACA,sBAAA;AACF","sourcesContent":[".content {\n  max-width: 100%;\n  width: 100vw;\n  background-color: inherit;\n}\n\n.bubble {\n  border-radius: 20px;\n  border: 1px solid var(--base-17);\n  padding: 0 0 2px 0;\n}\n\n.bubble:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n.quote {\n  margin-bottom: 9px;\n}\n\n.forward {\n  padding: 8px 12px 0;\n  margin-bottom: 4px;\n}\n\n.status-bar {\n  float: right;\n  margin: 4px 8px 10px 8px;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sender-name.wide-gap {\n  margin-bottom: 4px;\n}\n\n.thread-button {\n  margin: 2px 0 -2px 0;\n}\n\n.translate {\n  margin: 2px 0px -2px 0px;\n  padding-inline-end: 8px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ArticleBubble__content-b8c7cf`,
	"bubble": `ArticleBubble__bubble-eaee43`,
	"quote": `ArticleBubble__quote-f87763`,
	"forward": `ArticleBubble__forward-ba529f`,
	"status-bar": `ArticleBubble__status-bar-cbec2a`,
	"statusBar": `ArticleBubble__status-bar-cbec2a`,
	"sender-name": `ArticleBubble__sender-name-b34ede`,
	"senderName": `ArticleBubble__sender-name-b34ede`,
	"wide-gap": `ArticleBubble__wide-gap-cc7b5a`,
	"wideGap": `ArticleBubble__wide-gap-cc7b5a`,
	"thread-button": `ArticleBubble__thread-button-cb5a64`,
	"threadButton": `ArticleBubble__thread-button-cb5a64`,
	"translate": `ArticleBubble__translate-b13d66`
};
module.exports = ___CSS_LOADER_EXPORT___;
